module.exports = __webpack_public_path__ + "img/ht.96e33c78.svg";